module.exports = __webpack_public_path__ + "75c559768e470dfb90d6ed80561d468d.svg";